var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardNotificationsArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 11.25,
    viewBox: "0 0 10 11.25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Polygon_142",
    "data-name": "Polygon 142",
    d: "M4.753,1.549a1,1,0,0,1,1.743,0l3.915,6.96A1,1,0,0,1,9.54,10H1.71A1,1,0,0,1,.838,8.51Z",
    transform: "translate(0 11.25) rotate(-90)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardNotificationsArrow);
export default __webpack_public_path__ + "static/media/card-notifications-arrow.07473ba7f80c8149ceb220498651cf10.svg";
export { ForwardRef as ReactComponent };